export default __webpack_public_path__ + "b66f40ed776c498cc365319a0dc5dd8e.svg";